import {
  FETCH_DELETE_DOCUMENTS_PERMANENTLY_REQUEST,
  FETCH_DELETE_DOCUMENTS_PERMANENTLY_SUCCESS,
  FETCH_DELETE_DOCUMENTS_PERMANENTLY_FALUIRE,
} from './deleteDocumentsPermanentlyTypes'

const initialState = {
  loading: false,
  deleteDocumentsPermanentlyInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DELETE_DOCUMENTS_PERMANENTLY_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_DOCUMENTS_PERMANENTLY_SUCCESS : return {
      ...state,
      deleteDocumentsPermanentlyInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_DOCUMENTS_PERMANENTLY_FALUIRE : return {
      ...state,
      loading: false,
      deleteDocumentsPermanentlyInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
